import React from 'react';
import { Redirect } from 'react-router-dom';

/**
 * Component wrapper để kiểm tra trạng thái đăng nhập
 * Nếu user đã đăng nhập, điều hướng đến /home để hiển thị thông báo xác minh danh tính
 * Nếu chưa đăng nhập, hiển thị component con
 */
const AuthRedirectWrapper = ({ children }) => {
  // Kiểm tra trạng thái đăng nhập từ localStorage
  const userData = localStorage.getItem('ced:user-info');
  const user = userData ? JSON.parse(userData) : null;

  // Nếu user đã đăng nhập, điều hướng đến home để hiển thị thông báo xác minh danh tính
  if (user && user.accessToken) {
    return <Redirect to="/" />;
  }

  // Nếu chưa đăng nhập, hiển thị component con
  return children;
};

export default AuthRedirectWrapper;


